<div *ngIf="showFilter" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center" fxLayoutAlign.xs="start"
  fxLayoutGap="10px" fxLayoutGap.xs="0">
  <div class="mt-10 mlr-10">
    <!-- <mat-form-field class="full-width round-border-input mat-input-sm filled" appearance="outline">
      <span matPrefix class="mat-select-placeholder">
        <mat-icon>search</mat-icon>
      </span>
      <input matInput type="search" placeholder="{{ 'public.search' | translate }}" [formControl]="filterCtrl">
      <button mat-button *ngIf="filterCtrl.value" matSuffix mat-icon-button attr.aria-label="Clear"
        (click)="filterCtrl.setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field> -->
    <flex-search-input [formControl]="filterCtrl"></flex-search-input>
  </div>
</div>
<mat-accordion fxLayout="column" fxFlex="noshrink">
  <virtual-scroller fxFlex="noshrink" #scroll [items]="items">
    <mat-expansion-panel *ngFor="let contact of scroll.viewPortItems">
      <mat-expansion-panel-header>
        <div fxLayout="row" fxLayoutAlign="none center">
          <div class="avatar">
            <img mat-list-avatar [src]="contact.avatarUrl" data-ci="avatar-image" />
          </div>
          <h3 class="full-name">{{ contact.getFullName() }}</h3>
        </div>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <div fxLayout="row" fxLayoutAlign="start center">
          <div fxFlex="52px"></div>
          <div fxFlex="grow">
            <div fxLayout="column">
              <div fxFlex
                *ngIf="!contact.getOfficeExtension() && !contact.getOfficeNumber() && !contact.getMobileNumber()">
                {{ 'phonebook.content.no_phone' | translate }}
              </div>
              <div fxFlex *ngIf="contact.getOfficeExtension()">
                <div fxLayout="row" fxLayoutGap="10px">
                  <div fxFlex="85px">
                    {{ 'enterprise_contact.content.extension' | translate }}:
                  </div>
                  <div fxFlex="grow">
                    <a class="number" (click)="makeCall(contact.getOfficeExtension(), $event)">
                      {{ contact.getOfficeExtension() }}
                    </a>
                  </div>
                </div>
              </div>
              <div fxFlex *ngIf="contact.getOfficePhoneNumber()">
                <div fxLayout="row" fxLayoutGap="10px">
                  <div fxFlex="nogrow">
                    {{ 'enterprise_contact.content.tel' | translate }}:
                  </div>
                  <div fxFlex="auto">
                    <a class="number" (click)="makeCall(contact.getOfficePhoneNumber(), $event)">
                      {{ contact.getOfficePhoneNumber() }}
                    </a>
                  </div>
                </div>
              </div>
              <div fxFlex *ngIf="contact.getOfficeNumber()">
                <div fxLayout="row" fxLayoutGap="10px">
                  <div fxFlex="85px">
                    {{ 'enterprise_contact.content.office' | translate }}:
                  </div>
                  <div fxFlex="grow">
                    <a class="number" (click)="makeCall(contact.getOfficeNumber(), $event)">
                      {{ contact.getOfficeNumber() }}
                    </a>
                  </div>
                </div>
              </div>
              <div fxFlex *ngIf="contact.getMobileNumber()">
                <div fxLayout="row" fxLayoutGap="10px">
                  <div fxFlex="85px">
                    {{ 'enterprise_contact.content.mobile' | translate }}:
                  </div>
                  <div fxFlex="grow">
                    <a class="number" (click)="makeCall(contact.getMobileNumber(), $event)">
                      {{ contact.getMobileNumber() }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-expansion-panel>
  </virtual-scroller>
</mat-accordion>
